import { createContext, useContext, useState } from "react";

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      projects: "Proyectos",
      about: "Nosotros",
      quote: "Presupuesto",
      call: "622 66 93 78",
    },
    hero: {
      eyebrow: "La Pobla de Farnals · Valencia · 10 años de oficio",
      lines: ["Reformas, electricidad", "y construcción con", "rigor artesanal."],
      subtitle:
        "Del cuadro eléctrico a la reforma completa de tu vivienda o local. Proyectos pequeños y grandes, dirigidos personalmente por Alejandro Martínez Delgado.",
      ctaPrimary: "Pedir presupuesto gratuito",
      ctaSecondary: "Ver proyectos",
      cardCaption: "Obra en curso — Valencia",
      cardChip: "39.581°N · 0.324°W",
      scroll: "Desliza",
      stats: [
        { value: "10+", label: "Años de experiencia" },
        { value: "100%", label: "Trato directo con Alejandro" },
        { value: "24/48h", label: "Presupuesto sin compromiso" },
        { value: "S→XL", label: "Proyectos pequeños y grandes" },
      ],
    },
    marquee: [
      "Reformas integrales",
      "Electricidad certificada",
      "Fontanería",
      "Climatización y aire acondicionado",
      "Albañilería y edificación",
      "Presupuesto gratuito sin compromiso",
    ],
    manifesto: {
      eyebrow: "El oficio, por capítulos",
      heading: "Una manera de trabajar",
      sub: "Diez años levantando, renovando y reparando en Valencia. Esto es lo que sostiene cada proyecto.",
      chapters: [
        {
          n: "01",
          title: "Rigor técnico y compromiso",
          desc: "Cada proyecto, grande o pequeño, se ejecuta bajo normativa oficial y con acabados de máxima exigencia. Sin atajos.",
        },
        {
          n: "02",
          title: "Versatilidad de escala",
          desc: "Desde instalar un aire acondicionado o renovar un cuadro eléctrico, hasta la reforma completa de tu vivienda o local comercial.",
        },
        {
          n: "03",
          title: "Garantía de autor",
          desc: "Sin intermediarios opacos. Trato directo y transparente con Alejandro Martínez Delgado, y puntualidad estricta de entrega.",
        },
      ],
    },
    services: {
      eyebrow: "Servicios",
      heading: "Todo lo que tu proyecto necesita",
      sub: "Un solo equipo para toda la obra: albañilería, electricidad, fontanería y climatización.",
      items: [
        {
          id: "reformas",
          title: "Reformas integrales y construcción",
          tags: "Albañilería · Tabiquería · Parquet · Pintura",
          desc: "Transformación total de viviendas, baños, cocinas y locales comerciales en Valencia.",
        },
        {
          id: "electricidad",
          title: "Electricidad y boletines oficiales",
          tags: "Cuadros eléctricos · Iluminación LED · Domótica",
          desc: "Instalaciones de baja tensión, renovación de cableado antiguo y boletines de enganche.",
        },
        {
          id: "fontaneria",
          title: "Fontanería e instalaciones de agua",
          tags: "Tuberías multicapa · Sanitarios · Desagües",
          desc: "Sustitución de bajantes, instalación de grifería y reparación de fugas.",
        },
        {
          id: "climatizacion",
          title: "Climatización y aire acondicionado",
          tags: "Split inverter · Conductos · Bomba de calor",
          desc: "Cálculo térmico e instalación de equipos eficientes para el clima mediterráneo.",
        },
      ],
      cta: "Pedir presupuesto",
    },
    gallery: {
      eyebrow: "Proyectos",
      heading: "El trabajo habla",
      sub: "Una selección del tipo de trabajos que realizamos en Valencia y comarca.",
      note: "Nuestros trabajos y los servicios que realizamos, en imágenes — ampliamos la galería con cada proyecto nuevo.",
      filters: [
        { id: "all", label: "Todos" },
        { id: "reformas", label: "Reformas" },
        { id: "electricidad", label: "Electricidad" },
        { id: "fontaneria", label: "Fontanería" },
        { id: "climatizacion", label: "Climatización" },
      ],
      close: "Cerrar",
    },
    reviews: {
      eyebrow: "Clientes",
      heading: "Lo que dicen de nosotros",
      sub: "La confianza se construye obra a obra. Estas son las experiencias de quienes ya han trabajado con nosotros.",
      items: [
        {
          text: "Alejandro nos reformó el baño completo en menos de tres semanas. Presupuesto claro desde el primer día y un acabado impecable.",
          name: "María G.",
          job: "Reforma de baño · Benimaclet, Valencia",
        },
        {
          text: "Le llamamos por un problema eléctrico y acabó renovando todo el cuadro y la iluminación del local. Rápido, limpio y muy profesional.",
          name: "Jorge R.",
          job: "Instalación eléctrica · La Pobla de Farnals",
        },
        {
          text: "Instalación de aire acondicionado por conductos en pleno verano, sin demoras y explicándolo todo. Un trato directo que no dan las grandes empresas.",
          name: "Carmen y Luis",
          job: "Climatización · Alboraya",
        },
      ],
    },
    map: {
      eyebrow: "Dónde trabajamos",
      heading: "Valencia capital y comarca",
      sub: "Con base en La Pobla de Farnals, nos movemos por toda el área metropolitana de Valencia. Si tu proyecto está cerca, nos acercamos a verlo sin compromiso.",
      baseLabel: "Base de operaciones",
      areaLabel: "Zonas habituales de trabajo",
      towns: ["La Pobla de Farnals", "Valencia", "Alboraya", "Massamagrell", "Museros", "Foios", "Meliana", "Moncada", "Rafelbuñol"],
    },
    quote: {
      eyebrow: "Presupuesto gratuito",
      heading: "Cuéntanos tu proyecto",
      sub: "Respondemos en 24–48h laborables. Sin compromiso y sin letra pequeña.",
      name: "Nombre",
      namePh: "Tu nombre y apellidos",
      phone: "Teléfono",
      phonePh: "600 000 000",
      email: "Email (opcional)",
      emailPh: "tu@email.com",
      service: "¿Qué necesitas?",
      serviceOther: "Otro / varios",
      scale: "Tamaño del proyecto",
      scales: { small: "Pequeño arreglo", medium: "Proyecto medio", full: "Reforma completa" },
      message: "Cuéntanos más",
      messagePh: "Describe brevemente el trabajo, plazos y ubicación…",
      submit: "Enviar solicitud",
      sending: "Enviando…",
      successTitle: "Solicitud recibida",
      successBody: "Gracias por confiar en nosotros. Alejandro te contactará en 24–48h laborables.",
      whatsappCta: "Acelerar por WhatsApp",
      again: "Enviar otra solicitud",
      error: "No se pudo enviar. Inténtalo de nuevo o escríbenos por WhatsApp.",
      points: [
        "Respuesta en 24–48h laborables",
        "Presupuesto cerrado y sin compromiso",
        "Trato directo con el responsable",
      ],
    },
    footer: {
      tagline:
        "Reformas, electricidad y construcción en Valencia. Diez años de oficio, trato directo y acabados que duran.",
      contact: "Contacto",
      hours: "Horario",
      hoursValue: "Lun – Vie · 08:00 – 19:00",
      area: "Zona de trabajo",
      areaValue: "Valencia capital y comarca",
      legal: "CIF 42369201G · Calle Avilés 3, La Pobla de Farnals (46139), Valencia",
      admin: "Acceso",
      rights: "Todos los derechos reservados.",
      review: "Déjanos una reseña en Google",
    },
    wa: {
      prefill: "Hola Alejandro, me gustaría pedir presupuesto para un trabajo en Valencia.",
      label: "WhatsApp",
    },
    admin: {
      loginTitle: "Panel de solicitudes",
      loginSub: "Acceso privado — Obras Martinez",
      email: "Email",
      password: "Contraseña",
      login: "Entrar",
      loggingIn: "Entrando…",
      loginError: "Credenciales incorrectas o acceso bloqueado temporalmente.",
      title: "Solicitudes de presupuesto",
      subtitle: "Gestiona las solicitudes recibidas desde la web.",
      logout: "Salir",
      refresh: "Actualizar",
      exportCsv: "Exportar CSV",
      brandKit: "Kit de marca",
      back: "← Volver a la web",
      empty: "Aún no hay solicitudes.",
      loadError: "No se pudieron cargar las solicitudes.",
      deleteConfirm: "¿Eliminar esta solicitud?",
      th: {
        date: "Fecha",
        name: "Nombre",
        contact: "Contacto",
        service: "Servicio",
        message: "Mensaje",
        status: "Estado",
        actions: "Acciones",
      },
      status: { new: "Nueva", in_progress: "En curso", quoted: "Presupuestada", closed: "Cerrada" },
      scaleLabels: { small: "Pequeño", medium: "Medio", full: "Completa" },
      delete: "Eliminar",
    },
  },
  en: {
    nav: {
      services: "Services",
      projects: "Projects",
      about: "About",
      quote: "Free Quote",
      call: "622 66 93 78",
    },
    hero: {
      eyebrow: "La Pobla de Farnals · Valencia · 10 years of craft",
      lines: ["Renovations, electrical", "& building work with", "artisan precision."],
      subtitle:
        "From a fuse-box upgrade to the complete renovation of your home or business. Small and large projects, personally managed by Alejandro Martinez Delgado.",
      ctaPrimary: "Request a free quote",
      ctaSecondary: "See projects",
      cardCaption: "Work in progress — Valencia",
      cardChip: "39.581°N · 0.324°W",
      scroll: "Scroll",
      stats: [
        { value: "10+", label: "Years of experience" },
        { value: "100%", label: "Direct contact with Alejandro" },
        { value: "24/48h", label: "Free no-obligation quote" },
        { value: "S→XL", label: "Small and large projects" },
      ],
    },
    marquee: [
      "Full renovations",
      "Certified electrical work",
      "Plumbing",
      "Air conditioning & HVAC",
      "Masonry & construction",
      "Free no-obligation quotes",
    ],
    manifesto: {
      eyebrow: "The craft, in chapters",
      heading: "A way of working",
      sub: "Ten years building, renovating and repairing across Valencia. This is what holds every project together.",
      chapters: [
        {
          n: "01",
          title: "Technical rigour & commitment",
          desc: "Every project, large or small, is executed under official regulations with top-tier finishes. No shortcuts.",
        },
        {
          n: "02",
          title: "Versatility of scale",
          desc: "From installing an air conditioner or upgrading a fuse box, to the complete renovation of your home or commercial space.",
        },
        {
          n: "03",
          title: "A personal guarantee",
          desc: "No opaque middlemen. Direct, transparent dealing with Alejandro Martinez Delgado, and strict delivery punctuality.",
        },
      ],
    },
    services: {
      eyebrow: "Services",
      heading: "Everything your project needs",
      sub: "One team for the whole job: masonry, electrical, plumbing and air conditioning.",
      items: [
        {
          id: "reformas",
          title: "Full renovations & construction",
          tags: "Masonry · Drywall · Flooring · Painting",
          desc: "Complete transformation of homes, bathrooms, kitchens and commercial spaces in Valencia.",
        },
        {
          id: "electricidad",
          title: "Electrical & official certificates",
          tags: "Fuse boxes · LED lighting · Home automation",
          desc: "Low-voltage installations, renewal of old wiring and official connection certificates.",
        },
        {
          id: "fontaneria",
          title: "Plumbing & water systems",
          tags: "Multilayer piping · Fixtures · Drainage",
          desc: "Downpipe replacement, tapware installation and leak repair.",
        },
        {
          id: "climatizacion",
          title: "Air conditioning & HVAC",
          tags: "Inverter splits · Ducted systems · Heat pumps",
          desc: "Thermal calculation and installation of efficient systems for the Mediterranean climate.",
        },
      ],
      cta: "Request a quote",
    },
    gallery: {
      eyebrow: "Projects",
      heading: "The work speaks",
      sub: "A selection of the kind of work we carry out across Valencia and the surrounding region.",
      note: "Our work and the services we deliver, in pictures — we add to the gallery with every new project.",
      filters: [
        { id: "all", label: "All" },
        { id: "reformas", label: "Renovations" },
        { id: "electricidad", label: "Electrical" },
        { id: "fontaneria", label: "Plumbing" },
        { id: "climatizacion", label: "Air conditioning" },
      ],
      close: "Close",
    },
    reviews: {
      eyebrow: "Clients",
      heading: "What people say about us",
      sub: "Trust is built job by job. These are the experiences of those who have already worked with us.",
      items: [
        {
          text: "Alejandro renovated our entire bathroom in under three weeks. A clear quote from day one and a flawless finish.",
          name: "María G.",
          job: "Bathroom renovation · Benimaclet, Valencia",
        },
        {
          text: "We called him about an electrical fault and he ended up renewing the whole fuse box and the shop lighting. Fast, tidy and very professional.",
          name: "Jorge R.",
          job: "Electrical installation · La Pobla de Farnals",
        },
        {
          text: "Ducted air conditioning installed in the middle of summer, with no delays and everything explained. The direct treatment you don't get from big companies.",
          name: "Carmen & Luis",
          job: "Air conditioning · Alboraya",
        },
      ],
    },
    map: {
      eyebrow: "Where we work",
      heading: "Valencia city & surrounding region",
      sub: "Based in La Pobla de Farnals, we cover the whole Valencia metropolitan area. If your project is nearby, we'll come and see it with no obligation.",
      baseLabel: "Base of operations",
      areaLabel: "Usual work areas",
      towns: ["La Pobla de Farnals", "Valencia", "Alboraya", "Massamagrell", "Museros", "Foios", "Meliana", "Moncada", "Rafelbuñol"],
    },
    quote: {
      eyebrow: "Free quote",
      heading: "Tell us about your project",
      sub: "We reply within 24–48 working hours. No obligation, no small print.",
      name: "Name",
      namePh: "Your full name",
      phone: "Phone",
      phonePh: "600 000 000",
      email: "Email (optional)",
      emailPh: "you@email.com",
      service: "What do you need?",
      serviceOther: "Other / several",
      scale: "Project size",
      scales: { small: "Small repair", medium: "Medium project", full: "Full renovation" },
      message: "Tell us more",
      messagePh: "Briefly describe the job, timelines and location…",
      submit: "Send request",
      sending: "Sending…",
      successTitle: "Request received",
      successBody: "Thank you for your trust. Alejandro will contact you within 24–48 working hours.",
      whatsappCta: "Fast-track via WhatsApp",
      again: "Send another request",
      error: "Could not send. Please try again or message us on WhatsApp.",
      points: [
        "Reply within 24–48 working hours",
        "Fixed quote, no obligation",
        "Direct contact with the owner",
      ],
    },
    footer: {
      tagline:
        "Renovations, electrical work and construction in Valencia. Ten years of craft, direct dealing and finishes that last.",
      contact: "Contact",
      hours: "Hours",
      hoursValue: "Mon – Fri · 08:00 – 19:00",
      area: "Service area",
      areaValue: "Valencia city & surrounding region",
      legal: "Tax ID 42369201G · Calle Avilés 3, La Pobla de Farnals (46139), Valencia",
      admin: "Admin",
      rights: "All rights reserved.",
      review: "Leave us a Google review",
    },
    wa: {
      prefill: "Hello Alejandro, I would like to request a quote for a job in Valencia.",
      label: "WhatsApp",
    },
    admin: {
      loginTitle: "Enquiries panel",
      loginSub: "Private access — Obras Martinez",
      email: "Email",
      password: "Password",
      login: "Sign in",
      loggingIn: "Signing in…",
      loginError: "Incorrect credentials or access temporarily locked.",
      title: "Quote enquiries",
      subtitle: "Manage the requests received from the website.",
      logout: "Sign out",
      refresh: "Refresh",
      exportCsv: "Export CSV",
      brandKit: "Brand kit",
      back: "← Back to site",
      empty: "No enquiries yet.",
      loadError: "Could not load enquiries.",
      deleteConfirm: "Delete this enquiry?",
      th: {
        date: "Date",
        name: "Name",
        contact: "Contact",
        service: "Service",
        message: "Message",
        status: "Status",
        actions: "Actions",
      },
      status: { new: "New", in_progress: "In progress", quoted: "Quoted", closed: "Closed" },
      scaleLabels: { small: "Small", medium: "Medium", full: "Full" },
      delete: "Delete",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
